<template>
  <div class="sub-page-listing-content" v-if="pages.length" ref="subPageListingContent">
    <ul>
    <li v-for="page in pages" :key="page.id">
      <a :href="`${page.url}`">{{ page.title }}</a>
    </li>
  </ul>
  </div>
</template>

<script>
export default {
  name: 'SubPageListingComponent',
  props: {
    pages: {
      type: Array,
      required: true
    }
  },
  methods: {
    subPageListingContent () {
      const subPageListingContent = this.$refs.subPageListingContent
      if (!subPageListingContent) return

      const isDesktop = this.$root.isDesktop
      const subPageListingContentTop = subPageListingContent.offsetTop + 118
      const scrollPosition = window.scrollY

      if (isDesktop && scrollPosition > subPageListingContentTop) {
        const parentElement = subPageListingContent.parentElement
        let offsetLeftParents = 0
        let currentElement = parentElement
        while (currentElement) {
          if (currentElement.classList.contains('position-relative')) {
            offsetLeftParents += currentElement.offsetLeft
          }
          currentElement = currentElement.parentElement
        }
        const offsetLeft = offsetLeftParents + parentElement.offsetWidth
        const width = parentElement.clientWidth
        subPageListingContent.classList.add('affix')
        subPageListingContent.style.left = `${offsetLeft}px`
        subPageListingContent.style.width = `${(window.innerWidth - width) / 2}px`
        subPageListingContent.style.maxWidth = 'unset'
      } else {
        subPageListingContent.classList.remove('affix')
        subPageListingContent.style.left = ''
        subPageListingContent.style.maxWidth = ''
        subPageListingContent.style.width = ''
      }
    }
  },
  mounted () {
    this.subPageListingContent()
    const events = ['resize', 'scroll']
    events.forEach(event => {
      window.addEventListener(event, this.subPageListingContent)
    })
  },
  beforeDestroy () {
    const events = ['resize', 'scroll']
    events.forEach(event => {
      window.removeEventListener(event, this.subPageListingContent)
    })
  }
}
</script>
<style lang="scss">

.sub-page-listing-content {
  &.affix {
    position: fixed;
    left: unset;
    top: 118px;
    padding-top: 15px;
  }
  position:absolute;
  top:0;
  left:100%;
  max-width: calc((100vw - 100%) / 2);
  width: 100%;
  padding: 0 10px;
  z-index: 1;

  ul{
    list-style-type: none;
    padding-left:10px;
    &:first-child{
      border-left: 4px solid $primary;
    }
    ul{
      margin-left: 20px;
      padding-left:0;
    }

    li{
      a{
        text-decoration: none;
      }
    }
  }

  @media (max-width: 1200px) {
    position: static;
    left: auto;
    right: 10px;
    max-width: 100%;
    padding: 0;
  }

  @media (max-width: 768px) {
    position: static;
    max-width: 100%;
    padding: 0;
  }
}
</style>
